export default __webpack_public_path__ + "static/media/ipX2.4a8112c4.svg";